import {AxiosPromise} from "axios";
import {CONSTANT_CONFIG} from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.QIS_SERVER_PREFIX}/compile`;
const endpoints = {
    list: () => `${RESOURCE_ENDPOINT}`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    create: () => `${RESOURCE_ENDPOINT}`,
    dropdown: () => `${RESOURCE_ENDPOINT}/dropdown`,
    delete: () => `${RESOURCE_ENDPOINT}/delete`,
    update: () => `${RESOURCE_ENDPOINT}`,
    getProductionData: () => `${RESOURCE_ENDPOINT}/get-production-data`,
    getTargetBlockData: () => `${RESOURCE_ENDPOINT}/get-target-block-data`,
    updateCropProductionVariety: (id: number) => `${RESOURCE_ENDPOINT}/update-crop-production-variety/${id}`,
    updateCropTargetVariety: (id: number) => `${RESOURCE_ENDPOINT}/update-crop-target-variety/${id}`,
}

export default class CropCompilation {
    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.list();
        return HttpService.get(url, params, headers);
    }

    public getById = (id: any): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url);
    }

    public create = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    }

    public dropdown = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.dropdown();
        return HttpService.get(url, params, headers);
    }

    public delete = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.delete();
        return HttpService.post(url, payload, params, headers);
    }

    public update = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.update();
        return HttpService.put(url, payload, params, headers);
    }

    public getProductionData = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getProductionData();
        return HttpService.post(url, payload, params, headers);
    }

    public getTargetBlockData = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getTargetBlockData();
        return HttpService.post(url, payload, params, headers);
    }

    public updateCropProductionVariety = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updateCropProductionVariety(id);
        return HttpService.put(url, payload, params, headers);
    }

    public updateCropTargetVariety = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updateCropTargetVariety(id);
        return HttpService.put(url, payload, params, headers);
    }
}
